import { render } from "./antiChart.vue?vue&type=template&id=11b6f17c"
import script from "./antiChart.vue?vue&type=script&lang=js"
export * from "./antiChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__